// Single source of truth for the backend API base URL.
//
// Why this exists: the site is deployed as two Render services —
//   • frontend static site  → https://ctrlweb-1.onrender.com  (custom domain ctrl.am)
//   • backend Express API    → https://ctrlweb.onrender.com
// A misconfigured REACT_APP_API_URL once pointed the frontend at its OWN
// origin, so every /api/... call looped back to the static site and got the
// SPA index.html instead of JSON — breaking login and every request.
//
// This resolver is defensive: in production it always targets the real API
// host, ignoring an env value that (wrongly) points back at our own origin.

const PROD_API_URL = "https://ctrlweb.onrender.com";
const DEV_API_URL = "http://localhost:5000";

function resolveApiBase() {
    const env = (process.env.REACT_APP_API_URL || "").trim();

    // Non-browser / build-time context: honour env, fall back to dev.
    if (typeof window === "undefined") return env || DEV_API_URL;

    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") {
        return env || DEV_API_URL;
    }

    // Production: there is exactly one backend, so always use it. We deliberately
    // ignore REACT_APP_API_URL here — it has been misconfigured on Render to point
    // at the frontend's own static-site host (ctrlweb-1.onrender.com), which has no
    // CORS headers and returns the SPA index.html, causing "Failed to fetch".
    return PROD_API_URL;
}

const API_URL = resolveApiBase();

export default API_URL;
